module.exports = __webpack_public_path__ + "img/howellcare_main4.b55abfad.jpeg";